import { render, staticRenderFns } from "./FileContextMenu.vue?vue&type=template&id=54aff5ff&"
import script from "./FileContextMenu.vue?vue&type=script&lang=js&"
export * from "./FileContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./FileContextMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports